import { render } from "./NewTenantModal.vue?vue&type=template&id=68916d5c&ts=true"
import script from "./NewTenantModal.vue?vue&type=script&lang=ts"
export * from "./NewTenantModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__